import { InviteToPortalButton } from '@Components/InviteToPartnershipButton';
import { type ApiAddress, type ApiContact, EnumAddressRole, type InviteToPartnershipRequest } from '@Model';
import { Column, type Result } from '@synqo/frontend-component-library';
import { contactColumns } from '../../constants/TableColumns';

interface GetContactColumnsWithPortalInviteOptions {
    isPortalEnabled: boolean;
    isInviteLocked?: boolean;
    customerAddress: ApiAddress;
    inviteToPartnership: (request: InviteToPartnershipRequest) => Promise<Result<boolean>>;
    existingPortalEmails: Set<string>;
    pendingPortalEmails: Set<string>;
    rejectedPortalEmails: Set<string>;
}

export const getContactColumnsWithPortalInvite = ({
    isPortalEnabled,
    isInviteLocked,
    customerAddress,
    inviteToPartnership,
    existingPortalEmails,
    pendingPortalEmails,
    rejectedPortalEmails,
}: GetContactColumnsWithPortalInviteOptions): Column<ApiContact>[] => {
    const columns: Column<ApiContact>[] = [...contactColumns];

    const { id: customerAddressId, roles } = customerAddress;

    if (isPortalEnabled && (roles.includes(EnumAddressRole.Debtor) || roles.includes(EnumAddressRole.Creditor))) {
        columns.push({
            name: 'portal_invite',
            disableColumnFilter: true,
            disableColumnSort: true,
            label: '',
            renderCell: ({ rowData }) => {
                const email = (rowData.email ?? '').toLowerCase().trim();

                return (
                    <InviteToPortalButton
                        key={`inviteToPortalButton_${rowData.id}`}
                        contact={rowData}
                        addressId={customerAddressId}
                        inviteToPartnership={inviteToPartnership}
                        locked={isInviteLocked}
                        alreadyHasAccess={existingPortalEmails.has(email)}
                        invitationPending={pendingPortalEmails.has(email)}
                        invitationRejected={rejectedPortalEmails.has(email)}
                    />
                );
            },
        });
    }

    return columns;
};
